const getQueryParams = search => {
  const params = new URLSearchParams(search);
  return Object.fromEntries(params);
};
export const getPersonalizationQueryParams = search => {
  const params = getQueryParams(search);
  const strategyId = Number(params.fromPersonalizationStrategyId);
  return {
    fromCreate: params.fromRedirect === 'createVariant',
    strategyId: isNaN(strategyId) ? undefined : strategyId
  };
};
const createSearchString = params => {
  const filteredParams = Object.entries(params).filter(([__, value]) => !!value).map(([key, value]) => [key, value.toString()]);
  return new URLSearchParams(filteredParams).toString();
};
export const createPersonalizationSearchString = params => {
  const baseSearchString = createSearchString({
    fromRedirect: params.fromCreate ? 'createVariant' : undefined,
    fromPersonalizationStrategyId: params.strategyId
  });
  return baseSearchString ? `?${baseSearchString}` : '';
};